var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.235,
    height: 21.427,
    viewBox: "0 0 44.235 21.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.728,141.49l0,0L34.7,132.5a1.728,1.728,0,0,0-2.438,2.45l6.062,6.033H1.728a1.728,1.728,0,1,0,0,3.456H38.322l-6.062,6.033a1.728,1.728,0,0,0,2.438,2.45l9.029-8.985,0,0A1.729,1.729,0,0,0,43.728,141.49Z",
    transform: "translate(0 -132)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.2405fa1028d9eba763b668dc0b69beb6.svg";
export { ForwardRef as ReactComponent };